// @flow
import {DropdownControlled} from '@homeaway/react-dropdown';
import React from 'react';
import {connect} from 'react-redux';
// //
// Begin: SERP dependencies
import {FilterBarDropdown} from '../../../components/FilterBar/FilterBar';
import DropdownPanel from '../../../components/DropdownPanel/DropdownPanel';
import type {State as ReduxState} from '../../../reducers/index';
import {HA_TRAVSEG_SERP_FILTER} from '../../../abacus/experiments';
// //
// End: SERP dependencies

import isFamilyFriendlySelected from '../../utils/isFamilyFriendlySelected';
import {ForFamiliesFilter} from '../ForFamiliesFilter/ForFamiliesFilter';
import Experiment from '../Experiment/Experiment';

import './SegmentationFilterBarDropdown.less';

type StateProps = {
    isSelected: boolean
};

type OwnProps = {
    dropdownId: string,
    open: boolean,
    onBlur: Function,
    onDropdownClick: Function,
    onTouch: Function,
    onFamilyFilterSwitchChange: Function
};

type Props = StateProps & OwnProps;

export function SegmentationFilterBarDropdown({
    isSelected,
    dropdownId,
    open,
    onBlur,
    onDropdownClick,
    onTouch,
    onFamilyFilterSwitchChange
}: Props) {
    return (
        <FilterBarDropdown
            dropdownClass="SegmentationDropdown"
            dataWdio="SegmentationDropdown"
            isSelected={isSelected}
        >
            <DropdownControlled
                id={dropdownId}
                label={isSelected ? 'For families' : 'Group type'}
                onDropdownClick={onDropdownClick}
                onBlur={onBlur}
                onTouch={onTouch}
                open={open}
            >
                <DropdownPanel>
                    <ForFamiliesFilter
                        checked={isSelected}
                        onSwitchChange={onFamilyFilterSwitchChange}
                    />
                </DropdownPanel>
            </DropdownControlled>
        </FilterBarDropdown>
    );
}

type ContainerProps = $Shape<Props> & {
    isVisible: boolean,
    hasVariant: boolean
};

function SegmentationFilterBarDropdownContainer({
    isVisible,
    hasVariant,
    ...rest
}: ContainerProps) {
    const props: $Shape<Props> = rest;
    return isVisible ? (
        <Experiment experimentName={HA_TRAVSEG_SERP_FILTER}>
            {({evaluationData: {value}}) =>
                value ? <SegmentationFilterBarDropdown {...props} /> : null
            }
        </Experiment>
    ) : null;
}

const mapStateToProps = ({
    searchParams,
    segmentation: {hasEnoughSpaceInFilterBar}
}: ReduxState) => ({
    isSelected: isFamilyFriendlySelected(searchParams),
    isVisible: hasEnoughSpaceInFilterBar
});

export default connect(mapStateToProps)(SegmentationFilterBarDropdownContainer);
